import { cn } from "@/lib/utils";

/** An icon, a heading, a line of explanation and the action that resolves it. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: React.ElementType;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center px-6 py-14 text-center",
        className,
      )}
    >
      <div className="mb-4 rounded-full border border-border bg-muted/40 p-3.5">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
      {/* Sans, not the display serif: index.css puts every h1-h3 in Bodoni,
          whose hairlines drop out at this size on a dark ground. */}
      <h3 className="font-sans text-[15px] font-bold uppercase tracking-eyebrow text-foreground">
        {title}
      </h3>
      {description && (
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
